import * as Yup from "yup";

const CounterCreationSchema = Yup.object({
  name: Yup.string().required("name is required"),
  dept: Yup.string().required("department is required"),
  code: Yup.string().required("Code is required"),
});
export default CounterCreationSchema;
